import React, { useEffect, useState, useRef } from "react";
import { Box, Flex, Button, ButtonGroup } from "@chakra-ui/react";
//import { ColorModeSwitcher } from "./ColorModeSwitcher";
import { useNavigate } from "react-router-dom";
import Spline from "@splinetool/react-spline";

import { Social } from "./Social";
import { CityBackground } from "./CityBackground";

import { FaVolumeUp, FaVolumeMute } from "react-icons/fa";

import music from "./mainMusic.mp3";

export const Home = () => {
  const navigate = useNavigate();
  const [audio, setAudio] = useState(new Audio(music));
  audio.id = "musicbackground";
  audio.loop = true;
  //audio.autoplay = true;

  const [play, setPlay] = useState(true);

  useEffect(() => {
    if (play) {
      audio.play();
    } else {
      audio.pause();
    }
  }, [play]);

  return (
    <Box>
      <CityBackground />
      <Box
        h="100vh"
        minWidth="100%"
        zIndex="2"
        position="fixed"
        top="0"
        left="0"
      >
        <Spline
          onMouseDown={(e) => {
            audio.pause();
            setTimeout(() => {
              navigate("/secret");
            }, 1500);
          }}
          scene="https://prod.spline.design/sGiKUK6iXIcnlyEu/scene.splinecode"
        />
        {/* <iframe
          title="click :)"
          src="https://my.spline.design/untitled-902c295c96ff3e6bb2f162d7f27a039d/"
          width="100%"
          height="100%"
      ></iframe>*/}
      </Box>
      <Flex position="fixed" zIndex="3" bottom="0" right="0" padding="10px">
        <ButtonGroup
          padding="20px"
          borderRadius="12px"
          backdropFilter="blur(12px)"
          p="0px"
        >
          <Button
            bg="transparent"
            _hover={{ background: "tranparent" }}
            _active={{ background: "tranparent" }}
            size="md"
            borderRadius="16px"
            onClick={() => {
              setPlay(!play);
            }}
          >
            {play ? (
              <FaVolumeUp color="white" size="20px" />
            ) : (
              <FaVolumeMute color="white" size="20px" />
            )}
          </Button>
          <Social />
          {/*<ColorModeSwitcher justifySelf="flex-end" />*/}{" "}
        </ButtonGroup>
      </Flex>
    </Box>
  );
};
